import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utilitaire pour combiner et fusionner les classes CSS de manière intelligente
 * Utilise clsx pour la logique conditionnelle et tailwind-merge pour la fusion des classes Tailwind
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
